export default {
    responseActionConstants: {
        callToActionResponseActionName: "CallToActionButton",
        disableCallToActionResponseActionName: "DisableCallToActionButton",
        disableSurveyResponseActionName: "DisableSurveyLinks",
        displayItemAccordion: {
            name: "DisplayItemAccordion",
            parameters: {},
        },
        inlineSurveyResponseActionName: ["InlineSurvey"],
        uploadHistory: "UploadChatHistory",
    },
    ResponseActions: {
        displayFeedbackPanes: {
            actionName: "DisplayFeedbackPanes",
            paneTypes: {
                calendarWidget: "CalendarWidget",
                datacollection: "DataCollection",
                ok: "OK",
                options: "Options",
                textarea: "TextArea",
                transition: "Transition",
                yesno: "YesNo",
            },
            inputTypes: {
                combo: "Combo",
                text: "Text",
            },
            nextPaneEndKey: "END",
            parameters: {
                closeIcon: "closeIcon",
                feedbackPanes: "feedbackPanes",
                header: "header",
                metadata: "metadata",
                paneId: "paneId",
                paneType: "paneType",
                prompt: "prompt",
            },
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/response-action-constants.ts